import {TrackingService} from "./tracking_service";
import {TrackingFeatureLabels} from "./types";


export class MSP {
    private readonly trackingService: TrackingService;
    private readonly _featureOrder: number;
    private readonly _featureIndex: number;
    private readonly imageId: string;
    private readonly targetUrl: string;
    private readonly featureId: string;
    private readonly parentFeatureId: string;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels;
    private readonly masNextPiTrackingLabels: TrackingFeatureLabels;
    private readonly _item: HTMLLinkElement;

    constructor(private container: Element) {
        this._item = container.querySelector('.promo-msp__container a')!;
        this._featureOrder = this.getFeatureOrder(this.container);
        this._featureIndex = this.getFeatureIndex(this.container);
        this.imageId = this.getImageId(this.container);
        this.targetUrl = this.getTargetUrl(this.container);
        this.featureId = this.getFeatureId(this.container)
        this.parentFeatureId = this.getParentFeatureTrackingId(this.featureId);
        this.masFeatureTrackingLabels = this.getMasFeatureTrackingLabels(container);
        this.masNextPiTrackingLabels = this.getMasNextPiTrackingLabels(container);

        this.trackingService = new TrackingService()

        this.trackLoaded();
        this._item.addEventListener("click", (e: MouseEvent) => this.trackClick(e), false);
        this.registerVisibleTrackObserver();
    }

    trackClick(e: MouseEvent): void {
        if (e.target instanceof Element) {
            this.trackingService.sendClickTrackingEvent(this.featureId, this.parentFeatureId, this._featureOrder, this.imageId, this.targetUrl, this._featureIndex, this.masFeatureTrackingLabels, this.masNextPiTrackingLabels);
        }
    }

    trackLoaded(): void {
        this.trackingService.sendInitialLoadedTrackingEvent(this.featureId, this.parentFeatureId, this._featureOrder, this.imageId, this.targetUrl, this._featureIndex, this.masFeatureTrackingLabels);
    }

    registerVisibleTrackObserver(): void {
        /*                                     */
        const observer = new IntersectionObserver((entries) => {
            const intersectingEntries = entries.filter((entry) => entry.isIntersecting);
            if (intersectingEntries.length > 0) {
                this.trackingService.sendVisibleTrackingEvent(this.featureId, this.parentFeatureId);
                observer.unobserve(this.container);
            }
        }, {});

        observer.observe(this.container);
    }

    private getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute("data-feature-tracking-labels");
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private getMasNextPiTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataMasNextPiTrackingLabels = container.closest('[data-next-pi-tracking-labels]')?.getAttribute("data-next-pi-tracking-labels");
        return dataMasNextPiTrackingLabels ? JSON.parse(dataMasNextPiTrackingLabels) : {};
    }

    private getFeatureOrder(container: Element): number {
        const featureOrderOverride = this.container.getAttribute("data-feature-position-override");
        if(featureOrderOverride) {
            return featureOrderOverride ? parseInt(featureOrderOverride, 0) : -1;
        }
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    private getImageId(container: Element): string {
        return container.getAttribute('data-image-id')!;
    }

    getTargetUrl(container: Element): string {
        return container.querySelector("a")!.getAttribute("href") ?? "";
    }

    private getFeatureIndex(container: Element): number {
        return parseInt(container.getAttribute('data-feature-index')!, 0);
    }

    private getFeatureId(container: Element): string {
        return container.getAttribute('data-feature-id')!;
    }

    private getParentFeatureTrackingId(featureId: string) {
        return `ft3_msp_${featureId}`;
    }

    /*            */
    get featureOrder(): number {
        return this._featureOrder;
    }

    /*            */
    get item(): HTMLLinkElement {
        return this._item;
    }

    /*            */
    get testContainer(): Element {
        return this.container;
    }

}